import React, { useCallback, useContext, useState } from 'react';
import { ItemList } from 'v2/models';
import { CurrentStateFilterContext } from 'v2/context/currentStateFilterContext';

interface ICurrentItemListProps {
  children: React.ReactNode;
  onChange: (itemList: ItemList) => void;
}

export const CurrentItemList = ({
  children,
  onChange,
}: ICurrentItemListProps) => {
  const [currentList, setCurrentList] = useState<ItemList>({
    is_all: false,
    list: [],
    view_all: false,
  });

  const setCurrentState: React.Dispatch<React.SetStateAction<ItemList>> =
    useCallback(
      (param) => {
        let newVal: ItemList;
        if (typeof param === 'function') {
          newVal = param(currentList);
        } else {
          newVal = param;
        }
        setCurrentList(newVal);
        onChange(newVal);
      },
      [currentList, onChange]
    );

  return (
    <CurrentStateFilterContext.Provider
      value={{ currentState: currentList, setCurrentState }}
    >
      {children}
    </CurrentStateFilterContext.Provider>
  );
};

export const useCurrentItemList = () => {
  return useContext(CurrentStateFilterContext);
};
